import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Unauthorized from './Unauthorized';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isUnauthorized, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.2rem',
        color: '#718096'
      }}>
        Loading...
      </div>
    );
  }

  if (user && isUnauthorized) {
    return <Unauthorized />;
  }

  if (!isAuthenticated) {
    // Save the full path including pathname, search, and hash
    const fullPath = location.pathname + location.search + location.hash;
    return <Navigate to="/login" state={{ from: fullPath }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;